import { render, staticRenderFns } from "./JudgesLayout.vue?vue&type=template&id=20ae620e&scoped=true&"
import script from "./JudgesLayout.vue?vue&type=script&lang=js&"
export * from "./JudgesLayout.vue?vue&type=script&lang=js&"
import style0 from "./JudgesLayout.vue?vue&type=style&index=0&id=20ae620e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae620e",
  null
  
)

export default component.exports